import React, { Component, Fragment } from 'react';
import ContentPDFDinamico from '../ContentPDFDinamico';
import { BlobProvider, PDFDownloadLink, PDFViewer, pdf } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';

export default class GeneratePDF extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isLoading: false
        };

    }

    generatePdfDocument = async () => {

        await this.setLoading()
        
        const blob = await pdf((
            <ContentPDFDinamico {...this.props} />
        )).toBlob();
            
        await this.setLoading()
        saveAs(blob, `exportação_sigem_${new Date().toISOString()}.pdf`);

    };

    setLoading = async () => {
        this.setState({ isLoading: !this.state.isLoading })
    }

    render() {
        return (
            <Fragment>
                <a className="btn btn-primary" onClick={ this.generatePdfDocument } >
                    Gerar Relatório Metas (Original e Retificada)
                </a>
                { this.state.isLoading ? <p>...gerando relatório</p> : null }
            </Fragment>
        );
        
    }
}
